var styles = {"tableView":"styles_table-view__aHDUn","overflowContainer":"styles_overflow-container__kslQs","empty":"styles_empty__rfsPa","pending":"styles_pending__74f23","table":"styles_table__YhUMu"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
